import React, {forwardRef, useImperativeHandle, useState, useEffect} from 'react';
import './UserInfoPopup.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsRotate, faCopy} from "@fortawesome/free-solid-svg-icons";
import LocalDataService from '../../api/LocalDataService';
import {toast} from "react-toastify";
import ApiService from "../../api/ApiService";
import {copyToClipboard} from "../../utils/clipboardUtils";

const UserInfoPopup = forwardRef((props, ref) => {
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupPosition, setPopupPosition] = useState({top: 0, left: 0});
    const [user, setUser] = useState(null);
    const [apiToken, setApiToken] = useState(null);
    const api = new ApiService();
    const userProfileRef = props.userProfileRef; // 获取UserProfile引用

    useEffect(() => {
        const userData = LocalDataService.load_user_data();
        setUser(userData);
        if (isPopupVisible) {
            loadApiKeyList();
        }
        // const token = LocalDataService.loadApiToken();
        // setApiToken(token);
        // 添加事件监听器
        const handleUserLoginStatusChange = () => {
            const userData = LocalDataService.load_user_data();
            setUser(userData);
            const token = LocalDataService.loadApiToken();
            setApiToken(token);
        };

        window.addEventListener('userLoginStatusChanged', handleUserLoginStatusChange);

        return () => {
            window.removeEventListener('userLoginStatusChanged', handleUserLoginStatusChange);
        };
    }, [isPopupVisible]);

    const togglePopup = (event) => {
        if (event && event.clientX && event.clientY) {
            const x = event.clientX - 40;
            const y = event.clientY + 40;
            const popupWidth = 260; // 弹窗宽度（根据实际调整）
            const popupHeight = 454; // 弹窗高度（根据实际调整）

            // 计算最终显示位置
            let adjustedLeft = x;
            let adjustedTop = y;

            // 如果弹窗向右超出屏幕
            if (x + popupWidth > window.innerWidth) {
                adjustedLeft = window.innerWidth - popupWidth;
            }

            // 如果弹窗向下超出屏幕
            if (y + popupHeight > window.innerHeight) {
                adjustedTop = window.innerHeight - popupHeight;
            }
            setPopupPosition({top: adjustedTop, left: adjustedLeft});
        }
        setIsPopupVisible(!isPopupVisible);
    };


    // 暴露方法给父组件
    useImperativeHandle(ref, () => ({
        togglePopup: (event) => togglePopup(event)
    }));

    const closePopup = (event) => {
        if (!event.target.closest('.popup')) {
            setIsPopupVisible(false);
        }
    };


    const loadApiKeyList = async () => {
        const getList = await api.get_api_token_list();
        if (getList.code === 200) {
            const list = getList.data;
            const token = list[0].token;
            LocalDataService.setApiToken(token);
            setApiToken(token);
        }
    };

    const resetApiKey = () => {
        api.create_api_token().then(async () => {
            // 刷新页面
            await loadApiKeyList();
        });
    };
    const handLogout = () => {
        LocalDataService.set_user_data(null);
        LocalDataService.set_login_data(null);
        // 触发用户状态更新事件
        window.dispatchEvent(new Event('userLoginStatusChanged'));
    };
    const menu1 = '/images/userInfo/user_info_menu_1.svg'
    const menu2 = '/images/userInfo/user_info_menu_2.svg'
    const menu3 = '/images/userInfo/user_info_menu_3.svg'
    const menu4 = '/images/userInfo/user_info_menu_4.svg'
    const menu5 = '/images/userInfo/user_info_menu_5.svg'
    return (
        <>
            {isPopupVisible && user && (
                <div className="popup-overlay" onClick={closePopup}>
                    <div className="popup" style={{top: `${popupPosition.top}px`, left: `${popupPosition.left}px`}}>
                        <div className="popup-content">
                            <p>{user?.user?.bindingMobile ? user.user.bindingMobile : '微信用户'}</p>
                            <p style={{color: '#7D7D7D'}}>ID: {user ? user.user.id : ''}</p>
                            <p>手机号：{user?.user?.bindingMobile ? user.user.bindingMobile : '未绑定'}{!user?.user?.isBindingMobile &&
                                <button style={{
                                    background: 'transparent',
                                    color: '#02C8E3',
                                    border: '#02C8E3',
                                    borderStyle: 'solid',
                                    padding: '2px 5px',
                                    borderWidth: '1px',
                                    borderRadius: '5px',
                                    marginLeft: '5px'
                                }} onClick={()=>{
                                    setIsPopupVisible( false)
                                    // 使用UserProfile引用显示登录模态框
                                    if (userProfileRef && userProfileRef.current) {
                                        userProfileRef.current.showLoginModal(true);
                                    }
                                }}>绑定</button>} </p>
                            <div style={{
                                alignItems: 'start',
                                background: '#24272B',
                                borderRadius: '3px',
                                padding: '6px'
                            }}>
                                <p style={{color: '#D1D1D1'}}>插件API密钥（api_token）</p>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: '#13161A',
                                    borderRadius: '3px',
                                    padding: '6px'
                                }}>
                                    <input type="text" value={apiToken} readOnly/>
                                    <FontAwesomeIcon icon={faCopy}
                                                     style={{padding: '5px', cursor: 'pointer', color: '#02C8E3'}}
                                                     onClick={() => copyToClipboard(LocalDataService.loadApiToken())}/>
                                    <FontAwesomeIcon icon={faArrowsRotate}
                                                     style={{padding: '5px', cursor: 'pointer', color: '#02C8E3'}}
                                                     onClick={resetApiKey}/>
                                </div>
                            </div>


                            <ul>
                                <li>
                                    <img src={menu1} width={16} alt={''} style={{marginRight: '20px'}}/>
                                    <a href="/ConsumptionRecordList">消费明细</a>
                                </li>
                                <li>
                                    <img src={menu2} width={16} alt={''} style={{marginRight: '20px'}}/>
                                    <a href="/ChargingStandardList">计费标准</a>
                                </li>
                                {/*<li><img src={menu3} width={16} alt={''} style={{marginRight: '20px'}}/>*/}
                                {/*    <a href="/AgentExecuteRecordList">智能体记录</a>*/}
                                {/*</li>*/}
                                <li><img src={menu3} width={16} alt={''} style={{marginRight: '20px'}}/>
                                    <a href="/WorkFlowExecuteRecordList">工作流记录</a>
                                </li>
                                <li><img src={menu4} width={16} alt={''} style={{marginRight: '20px'}}/>
                                    <a href="#">开发票</a></li>
                                <li>
                                    <img src={menu5} width={16} alt={''} style={{marginRight: '20px'}}/>
                                    <a href="/" onClick={(e) => {
                                        handLogout()
                                    }}>退出登录</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            )}
        </>
    );
});

export default UserInfoPopup;
